import React from 'react';

const DashboardFooter = () => {
    return (
        <footer className="bg-white py-4 text-center text-sm text-gray-600">
            <p>Copyright © 2025 TomaTech. All rights reserved.</p>
        </footer>
    );
};

export default DashboardFooter;